export default `
clip-path: polygon(0 15%, 65% 15%, 65% 0, 100% 50%, 65% 100%, 65% 85%, 0 85%);
`
